module.exports = __webpack_public_path__ + "img/top.a7a9881d.png";